<template>
    <div id="new-advert">
        <div class="breadcrumb">
            <span>信息流广告 ></span>
            <span>{{advertTitle}}的信息流广告 ></span>
            <span v-if="edit === false">新增广告</span>
            <span v-if="edit !== false">编辑广告</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
                <el-button class="right_f" type="primary" @click="saveAdvertInfo(1)">保存草稿</el-button>
                <el-button class="right_f" type="primary" @click="saveAdvertInfo(0)">发布</el-button>
            </span>
        </div>
        <div class="detail">
            <el-form ref="advertForm" :rules="rules" :model="advertForm" label-width="130px">
                <el-form-item label="终端：" prop="osType">
                    <el-radio v-model="advertForm.osType" label="0">全部</el-radio>
                    <el-radio v-model="advertForm.osType" label="1">安卓</el-radio>
                    <el-radio v-model="advertForm.osType" label="2">IOS</el-radio>
                </el-form-item>
                <el-form-item label="广告标题：" prop="description" required>
                    <el-input v-model="advertForm.title" placeholder="广告标题（15字以内）" class="flickerTitle"></el-input>
                </el-form-item>
                <el-form-item label="广告说明：" prop="description">
                    <el-input v-model="advertForm.description" placeholder="广告说明" class="flickerTitle"></el-input>
                </el-form-item>

                <el-form-item label="图片：" prop="imgUrl">
                    <el-upload :action="actionUrl" :with-credentials='true' accept="image/*" name="uploadFile"
                        type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-dragger__text">将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>

                <el-form-item label="等级：" prop="grade">
                    <el-radio v-model="advertForm.grade" label="0">高</el-radio>
                    <el-radio v-model="advertForm.grade" label="1">中</el-radio>
                    <el-radio v-model="advertForm.grade" label="2">低</el-radio>
                </el-form-item>

                <el-form-item label="开始时间：" prop="startTime" class="ad-time">
                    <el-date-picker v-model="advertForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="endTime" label="结束时间：" class="ad-time">
                    <el-date-picker v-model="advertForm.endTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="点击事件" prop="clickType" class="click-events">
                    <el-radio v-model="advertForm.clickType" label="0" style="margin-left:10px;">无跳转</el-radio>
                    <el-radio v-model="advertForm.clickType" label="1">跳转至URL：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="2">跳转至已有文章：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="3">跳转至已有话题：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="4">跳转至已有活动：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="5">跳转至微信小程序：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="6">跳转至支付宝小程序：</el-radio>
                    <el-radio v-model="advertForm.clickType" label="7">跳转至音频：</el-radio>

                    <el-input v-model="advertForm.targetUrl" class="bounceTitle"
                        v-if="shieldArray.indexOf(advertForm.clickType) > -1" :placeholder="placeholder"></el-input>
                </el-form-item>
                <!-- 微信小程序 -->
                <div v-if="advertForm.clickType == '5'" class="wx-app">
                    <el-form-item label="小程序原始Id：" class="wxApp-from" required>
                        <el-input v-model="advertForm.wxAppId" placeholder="请填写正确的小程序原始Id"></el-input>
                    </el-form-item>
                    <el-form-item label="路径地址：" class="wxApp-from">
                        <el-input v-model="advertForm.wxAppUrl" placeholder="请填写正确的路径地址"></el-input>
                    </el-form-item>
                </div>
                <!-- 支付宝小程序 -->
                <div v-if="advertForm.clickType == '6'" class="wx-app">
                    <el-form-item label="小程序原始Id：" class="wxApp-from" required>
                        <el-input v-model="advertForm.aliAppId" placeholder="请填写正确的小程序原始Id"></el-input>
                    </el-form-item>
                    <el-form-item label="路径地址：" class="wxApp-from">
                        <el-input v-model="advertForm.aliAppUrl" placeholder="请填写正确的路径地址"></el-input>
                    </el-form-item>
                </div>
                <!-- 音频 -->
                <div v-if="advertForm.clickType == '7'" class="wx-app">
                    <el-form-item label="专辑ID：" class="wxApp-from" required>
                        <el-input v-model="advertForm.albumId" placeholder="请填写专辑ID"></el-input>
                    </el-form-item>
                    <el-form-item label="主播名称：" prop="nickName" class="wxApp-from wx-app" required>
                        <el-input v-model="advertForm.nickName" placeholder="请填写主播名称"></el-input>
                    </el-form-item>
                    <el-form-item label="单曲数：" class="wxApp-from" required>
                        <el-input v-model="advertForm.albumCount" placeholder="请填写单曲数" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="是否付费：" prop="isPaid" class="wxApp-from" required>
                        <el-radio v-model="advertForm.isPaid" label="1">是</el-radio>
                        <el-radio v-model="advertForm.isPaid" label="0">否</el-radio>
                    </el-form-item>
                </div>

                <select-school :schObj="advertForm.schObj" @changeVal="getVal"></select-school>

            </el-form>
        </div>
    </div>
</template>
<script>
    import {
        mapState
    } from 'vuex'
    import {
        mapActions
    } from 'vuex'
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                advertType: 0,
                advertTitle: '',
                id: '',
                isEdit: false,
                operatorId: '',
                name: '',
                shieldArray: ['1', '2', '3', '4'],
                actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=7',
                advertForm: {
                    osType: '0',
                    imgUrl: "",
                    title: '',
                    description: '',
                    grade: '0',
                    status: "0",
                    startTime: "",
                    endTime: "",
                    clickType: "0",
                    targetUrl: "",
                    wxAppId: '',
                    wxAppUrl: '',
                    aliAppId: '',
                    aliAppUrl: '',
                    schObj: {
                        applicableCampus: "0",
                        shieldedSchools: [], //屏蔽的学校
                        openedSchools: [] //应用的学校
                    },
                    albumId: "",
                    nickName: "",
                    albumCount: "",
                    isPaid: '0'
                },
                rules: {
                    title: [{
                            required: true,
                            message: '请输入广告标题',
                            trigger: 'blur'
                        },
                        {
                            min: 1,
                            max: 5,
                            message: '长度不超过15个字符',
                            trigger: 'blur'
                        }
                    ],
                    imgUrl: [{
                        required: true,
                        message: '请上传图片',
                        trigger: 'change'
                    }],
                    startTime: [{
                        type: "date",
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }],
                    endTime: [{
                        type: "date",
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }]
                }
            }
        },
        components: {
            selectSchool
        },
        computed: {
            placeholder() {
                if (this.advertForm.clickType === '1') {
                    return '请填写正确的url地址'
                } else if (this.advertForm.clickType === '2') {
                    return '请填写正确的文章id'
                } else if (this.advertForm.clickType === '3') {
                    return '请填写正确的话题id'
                } else if (this.advertForm.clickType === '4') {
                    return '请填写正确的活动地址'
                } else {
                    return ''
                }
            },
        },
        mounted() {
            this.advertType = this.$util.getUrlParam('advertType');
            this.id = this.$util.getUrlParam('id');
            this.isEdit = this.$util.getUrlParam('id') ? true : false;
            this.operatorId = this.$store.state.user.userId;
            this.name = this.$store.state.user.name;
            if (this.isEdit) {
                this.getAdvertDetail();
            }

            if (this.advertType == '0') {
                this.advertTitle = '动态';
            } else if (this.advertType == 1) {
                this.advertTitle = '文章';
            } else if (this.advertType == 2) {
                this.advertTitle = '话题';
            } else {
                this.advertTitle = '通知';
            }
        },
        methods: {
            //提交前的判断
            preValid() {
                let promise = new Promise((resolve, reject) => {
                    if (!this.advertForm.imgUrl) {
                        this.$util.errorMsg("请选择图片");
                        reject();
                    }

                    if (!this.advertForm.startTime || !this.advertForm.endTime) {
                        this.$util.errorMsg("请填写开始时间或结束时间");
                        reject();
                    }
                    let startTime = new Date(this.advertForm.startTime).getTime();
                    let endTime = new Date(this.advertForm.endTime).getTime();
                    if (startTime > endTime) {
                        this.$util.errorMsg("请填写正确的结束时间");
                        reject();
                    }

                    if (this.advertForm.schObj.applicableCampus == '1' && this.advertForm.schObj.openedSchools
                        .length == 0) {
                        this.$util.errorMsg("请添加应用学校");
                        reject();
                    }

                    if (this.shieldArray.includes(this.advertForm.clickType) && !this.advertForm.targetUrl
                        .trim()) {
                        this.$util.errorMsg("点击事件的id或者url不能为空！");
                        reject();
                    }

                    if (this.advertForm.clickType === '5' && !this.advertForm.wxAppId.trim()) {
                        this.$util.errorMsg("微信小程序的原始id不能为空！");
                        reject();
                    }

                    if (this.advertForm.clickType === '5' && this.advertForm.wxAppId.indexOf('id=') > -1) {
                        this.$util.errorMsg("微信小程序的原始id输入格式错误！");
                        reject();
                    }
                    if (this.advertForm.clickType === '6' && !this.advertForm.aliAppId.trim()) {
                        this.$util.errorMsg("支付宝小程序的原始id不能为空！");
                        reject();
                    }

                    if (this.advertForm.clickType === '6' && this.advertForm.aliAppId.indexOf('appId=') > -1) {
                        this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
                        reject();
                    }

                    if (this.advertForm.clickType === '7') {
                        var re = /^[0-9]+$/;
                        if (!this.advertForm.albumId.trim()) {
                            this.$util.errorMsg("专辑ID不能为空！");
                            reject();
                        }
                        if (!this.advertForm.nickName.trim()) {
                            this.$util.errorMsg("主播名称不能为空！");
                            reject();
                        }
                        if (!this.advertForm.albumCount || !re.test(this.advertForm.albumCount)) {
                            this.$util.errorMsg("单曲数输入有误！");
                            reject();
                        }
                    }
                    resolve();
                });
                return promise;
            },
            // 保存的参数整理
            formatParamsHandle(saveType) {
                let targetUrl = '';
                if (this.advertForm.clickType == '0') {
                    targetUrl = '';
                } else if (this.advertForm.clickType == '5') {
                    // 微信小程序的id和url作为两个参数拼成字符串传给后台
                    if (this.advertForm.wxAppUrl && this.advertForm.wxAppUrl.trim()) {
                        targetUrl = 'id=' + this.advertForm.wxAppId.trim() + '&path=' + this.advertForm.wxAppUrl.trim();
                    } else {
                        targetUrl = 'id=' + this.advertForm.wxAppId.trim();
                    }
                } else if (this.advertForm.clickType == '7') {
                    targetUrl = 'id=' + this.advertForm.albumId + '&nickName=' + this.advertForm.nickName +
                        '&count=' + this.advertForm.albumCount + '&isPaid=' + this.advertForm.isPaid;
                } else if (this.advertForm.clickType == '6') {
                    // 支付宝小程序的id和url作为两个参数拼成字符串传给后台
                    if (this.advertForm.aliAppUrl && this.advertForm.aliAppUrl.trim()) {
                        targetUrl = 'appId=' + this.advertForm.aliAppId.trim() + '&page=' + this.advertForm.aliAppUrl
                            .trim();
                    } else {
                        targetUrl = 'appId=' + this.advertForm.aliAppId.trim();
                    }
                } else {
                    targetUrl = this.advertForm.targetUrl
                }

                let rootUnids = [],
                    schObj = this.advertForm.schObj;
                if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
                    for (let i = 0; i < schObj.shieldedSchools.length; i++) {
                        rootUnids.push({
                            name: schObj.shieldedSchools[i].name,
                            rootUnid: schObj.shieldedSchools[i].rootUnid * 1
                        })
                    }
                } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
                    for (let i = 0; i < schObj.openedSchools.length; i++) {
                        rootUnids.push({
                            name: schObj.openedSchools[i].name,
                            rootUnid: schObj.openedSchools[i].rootUnid * 1
                        })
                    }
                }

                let requestBody = {
                    type: this.advertType, // ⼴告类型 0:动态，1：头条，2：话题，3：通知
                    osType: this.advertForm.osType,
                    title: this.advertForm.title.trim(),
                    description: this.advertForm.description,
                    applicableCampus: schObj.applicableCampus * 1, //0,全部校区；1，部分校区；
                    startTime: new Date(this.advertForm.startTime).getTime(),
                    endTime: new Date(this.advertForm.endTime).getTime(),
                    grade: this.advertForm.grade, // 等级 0:高，1:中，2:低
                    imgUrl: this.advertForm.imgUrl,
                    clickType: this.advertForm.clickType * 1,
                    targetUrl: targetUrl,
                    campusList: rootUnids,
                    publishType: saveType, // 发布类型 0：发布，1：保存草稿
                    operatorId: this.operatorId,
                    name: this.name,
                };

                if (this.isEdit) {
                    requestBody.id = this.id
                }

                return requestBody;
            },
            // 保存
            saveAdvertInfo(saveType) {
                this.preValid().then(() => {
                    let reqBody = this.formatParamsHandle(saveType);
                    let url = this.$util.domain + '/information/stream/adAdd'
                    if (this.isEdit) {
                        url = this.$util.domain + '/information/stream/adUpdate'
                    }
                    this.$http({
                        method: 'POST',
                        url: url,
                        body: JSON.stringify(reqBody)
                    }).then(response => {
                        if (response.data.error == 10000) {
                            location.href = "/#/yunying/advert/advertManage?advertType=" + this
                                .advertType;
                        } else {
                            this.$util.errorMsg(response.data.message);
                        }
                    })
                })
            },

            // 获取广告详情信息
            getAdvertDetail() {
                let url = this.$util.domain + '/information/stream/' + this.id;

                this.$http({
                    method: 'GET',
                    url: url,
                }).then(response => {
                    if (response.data.error == 10000) {
                        let preObj = response.data.data;

                        // 点击事件的ID或URL的整理
                        let targetUrl = '',
                            wxAppId = '',
                            wxAppUrl = '',
                            aliAppId = '',
                            aliAppUrl = '',
                            albumId, nickName, albumCount, isPaid = '0';
                        if (preObj.clickType == 5) {
                            // 微信小程序地址拆分
                            wxAppId = this.$util.getUrlParam('id', preObj.targetUrl);
                            wxAppUrl = this.$util.getUrlParam('path', preObj.targetUrl);
                        } else if (preObj.clickType == 6) {
                            // 支付宝小程序地址拆分
                            aliAppId = this.$util.getUrlParam('appId', preObj.targetUrl);
                            aliAppUrl = this.$util.getUrlParam('page', preObj.targetUrl);
                            let query = this.$util.getUrlParam('query', preObj.targetUrl);
                            if (query) {
                                aliAppUrl = aliAppUrl + '&query=' + query;
                            }
                        } else if (preObj.clickType == 0) {
                            targetUrl = '';
                        } else if (preObj.clickType == 7) {
                            // 音频
                            albumId = this.$util.getUrlParam('id', preObj.targetUrl);
                            nickName = this.$util.getUrlParam('nickName', preObj.targetUrl);
                            albumCount = this.$util.getUrlParam('count', preObj.targetUrl);
                            isPaid = this.$util.getUrlParam('isPaid', preObj.targetUrl);
                        } else {
                            targetUrl = preObj.targetUrl;
                        }

                        this.id = preObj.id;

                        this.advertForm = {
                            osType: preObj.osType + '',
                            title: preObj.title,
                            imgUrl: preObj.imgUrl,
                            type: preObj.type + "",
                            status: preObj.status + '',
                            grade: preObj.grade + '',
                            description: preObj.description,
                            targetUrl: targetUrl ? targetUrl + '' : '',
                            clickType: preObj.clickType + '',
                            startTime: new Date(preObj.startTime),
                            endTime: new Date(preObj.endTime),
                            wxAppId: wxAppId,
                            wxAppUrl: wxAppUrl,
                            aliAppId: aliAppId,
                            aliAppUrl: aliAppUrl,
                            schObj: {
                                shieldedSchools: [],
                                openedSchools: [],
                                applicableCampus: preObj.applicableCampus ? preObj.applicableCampus + "" :
                                    "0"
                            },
                            albumId: albumId,
                            nickName: nickName,
                            albumCount: albumCount,
                            isPaid: isPaid
                        };

                        let schArray = preObj.campusList.map(item => {
                            return {
                                name: item.name,
                                rootUnid: item.rootUnid
                            }
                        });
                        preObj.applicableCampus == 0 ? (this.advertForm.schObj.shieldedSchools = schArray) : (
                            this.advertForm.schObj.openedSchools = schArray);

                    }
                })
            },

            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    this.advertForm.imgUrl = response.data;
                }
            },

            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = '/#';
                }
                this.$util.errorMsg('上传失败');
            },

            //获取子组件传递的参数
            getVal(res) {
                this.advertForm.schObj = res;
            },
            cancel() {
                history.go(-1);
            },

        }
    }
</script>
<style scoped>
    .ad-time {
        width: 400px;
    }

    .click-events .el-radio {
        display: block;
    }

    .wxApp-from {
        width: 600px;
        margin-left: 120px;
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// newAdvert.vue?0607d55c